import { useMemo } from "react";

export function useContextPostId() {
    const postId = useMemo(() => {
        const postElem = document.querySelector("article[data-post-id]");
        return (postElem as HTMLElement).dataset?.postId as string;
    }, []);
    return postId;
}
